import axios from "axios";
import { useState } from "react";
import { PartitionOutlined } from "@ant-design/icons";
import { Button, Input, InputNumber, Modal, Row, Progress } from "antd";
import { uploadToS3 } from "components/N";
import { swalError, swalSuccess } from "utils/swal";
import "./AIGeneration.scss";

function getRandomInt(max = 999999999999999999999999999) {
  return Math.floor(Math.random() * max);
}

function base64ToFile(base64String, fileName, mimeType = "image/png") {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type: mimeType || "application/octet-stream",
  });

  return new File([blob], fileName + getRandomInt(), {
    type: mimeType || "application/octet-stream",
  });
}
function blobToFile(blob, fileName) {
  return new File([blob], fileName, {
    type: blob.type,
  });
}

const AIGeneration = ({ onAddImage, className }) => {
  const [prompt, setPrompt] = useState("");
  const [numberOfImg, setNumberOfImg] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const downloadImage = async (base64) => {
    // const imageFile = base64ToFile(base64, prompt);
    const imageFile = blobToFile(base64, prompt);
    try {
      const uploadedUrl = await uploadToS3([{ file: imageFile }]);
      await onAddImage([{ url: uploadedUrl }]);
    } catch (e) {
      console.log("Error");
    }
  };

  const generateImage = async () => {
    try {
      setLoading(true);
      setProgress(0);
      const apiUrl = `${process.env.REACT_APP_API_URL}/openai/`;
      try {
        const response = await axios({
          method: "get",
          url: apiUrl,
          params: {
            prompt,
          },
          responseType: "blob",
          onDownloadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        });
        console.log("repsonse: ", response.data);
        await downloadImage(response.data);
        setIsModalOpen(false);
        swalSuccess("Image generated successfully");

      } catch (error) {
        swalError("Error generating image");
        console.error("Error making API request:", error);
      }
    } catch (e) {
      swalError(`Error generating image: ${e.message}`)
      console.log("Error", e);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        wrapClassName="ai-modal"
        title={null}
        footer={null}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        destroyOnClose
      >
        <Input.TextArea
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Input your prompt"
        />

        {loading && (
          <Progress
            percent={progress}
            style={{ marginTop: 20, width: "100%" }}
          />
        )}

        <Row className="number-img-btn">
          {/* Number of images: */}
          <Row className="row-ai">
            <InputNumber
              min={1}
              value={numberOfImg}
              onChange={(value) => setNumberOfImg(value)}
              className="input-number"
            />
            <Button
              onClick={generateImage}
              loading={loading}
              disabled={prompt.length === 0}
              className="generate-btn"
            >
              Generate
            </Button>
          </Row>
        </Row>
      </Modal>
      {className ? (
        <div
          className={className}
          onClick={showModal}
        >
          <div className="default-project-button-icon">
            <PartitionOutlined style={{ fontSize: "28px" }} />
          </div>
          <span className="default-project-button-label">Generate AI</span>
          <span className="default-project-button-desc">Create with AI</span>
        </div>
      ) : (
        <a
          className="dropdown-item"
          onClick={showModal}
        >
          <PartitionOutlined />
          Generate AI
        </a>
      )}
    </>
  );
};

export default AIGeneration;
